import "./css/spinner.scss";

export const Spinner = {
  start(element) {
    if (element.querySelector(".spinner")) {
      return;
    }

    const screen = document.createElement("div");
    screen.classList.add("spinner");
    screen.innerHTML = `
      <div class="icon is-large spinning-element">
        <i class="fa fa-3x fa-circle-notch"></i>
      </div>`;
    screen.querySelector(".spinning-element").classList.add("fast-spin");

    // Don't clobber positioning if it's already non-static
    const pos = getComputedStyle(element).position;
    if (pos === "static") {
      element.style.position = "relative";
    }

    element.appendChild(screen);
  },

  stop(element) {
    const spinner = element.querySelector(".spinner");
    spinner?.remove();
  },

  stopAll() {
    document.querySelectorAll(".spinner").forEach((e) => {
      this.stop(e.parentElement);
    });
  },
};

function targetsFor(startsEl) {
  const container = startsEl.closest("[data-starts-spinner]");
  if (!container) return [];
  const selector = container.getAttribute("data-starts-spinner");
  if (!selector) return [];

  return Array.from(document.querySelectorAll(selector));
}

document.addEventListener("click", (e) => {
  const trigger =
    e.target.closest("a[data-starts-spinner], button[data-starts-spinner]") ||
    e.target.closest("[data-starts-spinner] a, [data-starts-spinner] button");
  if (!trigger) return;

  // Skip if element has data-confirm - will handle via confirm:complete event
  if (trigger.hasAttribute("data-confirm")) {
    return;
  }

  targetsFor(trigger).forEach((t) => Spinner.start(t));
});

document.addEventListener("submit", (e) => {
  const form = e.target.closest("form[data-starts-spinner]");
  if (!form) return;

  // Skip if form has data-confirm - will handle via confirm:complete event
  if (form.hasAttribute("data-confirm")) {
    return;
  }

  targetsFor(form).forEach((t) => Spinner.start(t));
});

// Handle data-confirm elements: start spinner only if user confirms.
document.addEventListener("confirm:complete", (e) => {
  const confirmed = e.detail[0]; // true if user confirmed, false if cancelled
  if (!confirmed) return;

  const trigger = e.target;
  if (trigger.closest("[data-starts-spinner]")) {
    targetsFor(trigger).forEach((t) => Spinner.start(t));
  }
});

document.addEventListener("rails-ujs:confirm", (e) => {
  const trigger = e.element;
  if (trigger.closest("[data-starts-spinner]")) {
    targetsFor(trigger).forEach((t) => Spinner.start(t));
  }
});

// Stop spinners when AJAX completes
document.addEventListener("ajax:complete", (e) => {
  const trigger = e.target;
  if (trigger.closest("[data-starts-spinner]")) {
    targetsFor(trigger).forEach((t) => Spinner.stop(t));
  }
});
